"use client";

import React from "react";
import { DrawerContext } from "./context";

export const useDrawer = () => {
  const context = React.useContext(DrawerContext);

  if (!context) {
    throw new Error("useDrawer must be used within DrawerProvider");
  }

  return context;
};
